<template>
  <div class="statusBar">
    <h3>Тема звонка:</h3>
    <ul id="main_status">
      <li v-for="item in statusList">
        <label v-bind:style="item.bg">
          <input type="radio" v-model="CallStatus" :value="item.name">
          <span>{{item.name}}</span>
        </label></li>
    </ul>
    <div v-if="subStatusList.length > 0">
      <h3>Уточнение:</h3>
      <ul>
        <li v-for="item in subStatusList">
          <label v-bind:style="item.bg">
            <input type="radio" v-model="SubCallStatus" :value="item.name">
            <span>{{item.name}}</span>
          </label>
        </li>
      </ul>
    </div>

    <div>
      <h3>Примечание:</h3>
      <textarea v-model="OperatorMsg"></textarea>
    </div>
    <div v-if="canSaveStatus">
      <div class="button" v-on:click="saveStatus">Зарегистрировать звонок</div>
    </div>
  </div>

</template>

<script>
  //todo дообавить поля перезвона, с датой и временем
  import StatusListLib from '@/gavnoCode/statusList';
  import {mapGetters, mapState} from 'vuex'

  export default {
    name: "statusBarIn",
    data: function () {
      return {
        statusList: StatusListLib.StatusListIncoming,
        subStatusList: [],
      }
    },
    methods: {
      chekRequriedFieldsForSaveStatus(){
        return new Promise((resolve,reject)=>{
          console.log(this.valueVuex['request']['WHERE_TO_FIND_US'])
          if (this.valueVuex['request']['WHERE_TO_FIND_US'].length == 0) {
            reject('Не заполнено поле "Откуда о нас узнали"');
            return false;
          }
          if (this.valueVuex['LeadInfo']['PHONE_FOR_CALL'].length < 18) {
            reject('Не заполнено поле телефон');
            return false;
          } else {
            this.$store.dispatch('saveSendData', {
              target: 'PHONE',
              form: 'request',
              value: this.valueVuex['LeadInfo']['PHONE_FOR_CALL']
            }).then(()=>{
              resolve();
            });
          }

        });
      },
      saveStatus:function(){

        // if (this.valueVuex['request']['WHERE_TO_FIND_US'].length == 0) {
        //   this.$store.commit('setContent', 'Не заполнено поле "Откуда о нас узнали"');
        //   this.$store.commit('showModal');
        //   return false;
        // }
        // // if (this.valueVuex['request']['PHONE'].length < 18) {
        // //   this.$store.commit('setContent', 'Не заполнено поле телефон');
        // //   this.$store.commit('showModal');
        // //   return false;
        // // }
        // if (this.valueVuex['LeadInfo']['PHONE_FOR_CALL'].length < 18) {
        //   this.$store.commit('setContent', 'Не заполнено поле телефон');
        //   this.$store.commit('showModal');
        //   return false;
        // } else {
        //   this.$store.dispatch('saveSendData', {
        //     target: 'PHONE',
        //     form: 'request',
        //     value: this.valueVuex['LeadInfo']['PHONE_FOR_CALL']
        //   });
        // }

        this.chekRequriedFieldsForSaveStatus().then(()=>{
          let SendData = {
            data:Object.assign({}, this.valueVuex),
            action:'Operator_saveStatus'
          };
          this.$store.commit('setContent', 'Сохранение звонка, ожидайте');
          this.$store.commit('showModal');

          this.$myApi.SendRequest(SendData, this, 'saveStatus', true).then((result) => {
            this.$store.commit('hideModal');
            this.$emit('loadNewLead');
          }).catch((msg) => {
            this.$store.commit('setContent', msg);
            this.$store.commit('showModal');
          });
        }).catch((mes)=>{
          this.$store.commit('setContent', mes);
            this.$store.commit('showModal');
        });

      },
      chekIssetSubStatus: function (item) {
        if (item.subStatus) {
          return true;
        } else {
          return false;
        }
      },
      returnStatusObject: function(value){
        //поиск объекта по значению
        let thisStatus = this.statusList.filter(item => {
          if (item.name == value) {
            return true;
          }
        });
        if(thisStatus.length === 1) {
          return thisStatus[0];
        } else {
          return [];
        }
      },
      selectedStatusObject: function(element, index){
        if (element.name == this.CallStatus) {
          return element;
        }
      }
    },
    watch: {
      CallStatus: function (value) {
        //смотрим на выбранный статус, если есть доп статусы показываем их, если заявка, то показываем форму
        let thisStatus = this.returnStatusObject(value);
        //пробел присваивается, потому, что блокируется запись изменения в хранилище, если пришла пусто....
        // хз зачем так сделал.
        this.SubCallStatus = ' ';
        if (this.chekIssetSubStatus(thisStatus)) {
          this.subStatusList = thisStatus.subStatus;
        } else {
          this.subStatusList = [];
        }
      },
    },
    computed:{
      canSaveStatus: function () {
        let xz = {};
        //проверяем есть ли возможность сохранить звонок без заявки
        if (this.CallStatus.length > 0){
          if (this.CallStatus == 'Оформлена заявка') { return  false;}
          xz = this.statusList.find(this.selectedStatusObject);
          if (xz.subStatus != undefined) {
            if(this.SubCallStatus.length > 1) {
              return true
            }
          } else {
            return true;
          }
        }
        return false;
      },
      CallStatus:{
        get(){
          return this.valueVuex['status']['CallStatus']
        },
        set(value){
          this.$store.dispatch('saveSendData',{
            target:'CallStatus',
            form:'status',
            value: value
          });
        }
      },
      SubCallStatus: {
        get(){
          return this.valueVuex['status']['SubCallStatus']
        },
        set(value){

          this.$store.dispatch('saveSendData',{
            target:'SubCallStatus',
            form:'status',
            value: value
          });
        }
      },
      OperatorMsg: {
        get(){
          return this.valueVuex['status']['OperatorMsg']
        },
        set(value){
          this.$store.dispatch('saveSendData',{
            target:'OperatorMsg',
            form:'status',
            value: value
          });
        }
      },
      ReCallDate: {
        get(){
          return this.valueVuex['status']['ReCallDate']
        },
        set(value){
          this.$store.dispatch('saveSendData',{
            target:'ReCallDate',
            form:'status',
            value: value
          });
        }
      },
      ReCallTime: {
        get(){
          return this.valueVuex['status']['ReCallTime']
        },
        set(value){
          this.$store.dispatch('saveSendData',{
            target:'ReCallTime',
            form:'status',
            value: value
          });
        }
      },
      ...mapGetters(['getStatusList']),
      ...mapState({
        valueVuex: state => state.requestField.sendData,
        statusVuex: state => state.requestField.workData
      })
    }
  }
</script>

<style scoped>
  .statusBar {
  }

  .statusBar ul {
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    margin: 0;
    padding: 0;
  }

  .statusBar ul li {
    width: 16%;
    min-height: 45px;
    margin: 3px 0.8% 3px 0;
  }
  .statusBar ul li:nth-child(6n) {margin-right: 0;}

  .statusBar ul li label {
    display: flex;
    align-items: center;
    height: 100%;
    cursor: pointer;
    justify-content: flex-start;
    text-align: left;
  }

  .statusBar ul li label:hover {
    background: rgba(15, 87, 64, 0.11);
    box-shadow: 1px 2px 6px 4px rgba(11, 58, 15, 0.66);
  }

  .statusBar ul li label input {
    width: 20px;
  }

  .statusBar ul li label span {
    font-size: 15px;
    line-height: 0.8;
    width: calc(100% - 30px);
  }

  textarea {
    width: calc(100% - 2px - 10px);
    height: 80px;
    border: 1px solid rgb(15, 87, 64);
  }
</style>
